<p-dialog
    [(visible)]="visible"
    [header]="'service.settings.specialistRecord.workType.label' | translate"
>
    <div class="flex gap-large pt-5">
        <app-check-input [form]="form" id="active"
            label="service.settings.specialistRecord.workType.fields.active"
        ></app-check-input>
        <app-text-input [form]="form" id="name"
            label="service.settings.specialistRecord.workType.fields.name"
        ></app-text-input>
        <app-text-input [form]="form" id="description"
            label="service.settings.specialistRecord.workType.fields.description"
        ></app-text-input>
    </div>

    <ng-template #footer>
        <app-action-buttons (primaryClickEvent)="submit()" (secondaryClickEvent)="show(false)"></app-action-buttons>
    </ng-template>
</p-dialog>
